import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";
import { Eyebrow, Reveal } from "./Primitives";

export const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = TESTIMONIALS[active];
  return (
    <section data-testid="testimonials-section" className="bg-ink py-24 text-paper lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow light>Here's what our customers say</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] sm:text-5xl">Founders who <span className="font-serif font-normal italic text-cobalt-200">stopped guessing.</span></h2>
          </Reveal>
          <div className="mt-10 flex flex-col">
            {TESTIMONIALS.map((x, i) => (
              <button
                key={x.name}
                data-testid={`testimonial-tab-${i}`}
                onClick={() => setActive(i)}
                className={`group relative border-t border-paper/15 py-5 text-left transition-colors ${i === active ? "text-paper" : "text-paper/60 hover:text-paper"}`}
              >
                {i === active && <motion.span layoutId="t-bar" className="absolute left-0 top-[-1px] h-[2px] w-full bg-cobalt-400" />}
                <span className="block font-display text-lg font-semibold">{x.name}</span>
                <span className="block text-[14px] text-paper/60">{x.role}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="relative min-h-[420px] lg:col-span-8 lg:pl-10">
          <Quote className="h-14 w-14 text-cobalt-400" strokeWidth={1.2} />
          <AnimatePresence initial={false}>
            <motion.blockquote
              key={active}
              data-testid="testimonial-active-quote"
              initial={{ opacity: 0, y: 24, filter: "blur(6px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -16, filter: "blur(6px)", position: "absolute" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="mt-8"
            >
              <p className={`font-serif leading-[1.2] text-paper ${t.quote.length > 250 ? "text-2xl sm:text-3xl" : "text-3xl sm:text-5xl"}`}>“{t.quote}”</p>
              <footer className="mt-10 flex items-center gap-4">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-cobalt-700 font-display text-lg font-bold">{t.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}</span>
                <span><span className="block font-semibold">{t.name}</span><span className="text-[14px] text-paper/60">{t.role}</span></span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
